<template>
  <div class="ibox">

    <div class="ibox-title text-center bg-light border-left border-right">
      <h5><i class="fa fa-bell-o"></i> Notification</h5>
    </div>

    <div class="ibox-content border-left border-bottom border-right pt-3 pb-3">
      <input type="hidden" :name="selectedUsersFieldName" :value="stringUsers">

      <div class="form-group mb-0">
        <textarea :name="textAreaFieldName" v-model="text" class="form-control" rows="3" placeholder="Please enter the notification text or leave the field blank to ignore it."></textarea>
      </div>

      <template v-if="text.trim() !== ''">

        <div class="user-labels mt-3">
          <strong>Recipients:</strong>
          <span v-for="user in users" class="badge badge-success">
            {{ (user.last_name + ', ' + user.first_name).trim() }}
            <i v-if="users.length > 1" class="fa fa-times" @click="removeUser(user.id)"></i>
          </span>
        </div>

        <user-typeahead
          placeholder="Find and select user to add to list..."
          @userSelected="addNewUser"></user-typeahead>
      </template>
    </div>

  </div>
</template>

<script>
import UserTypeahead from "./UserTypeahead.vue";

export default {

  props: {

    // Textarea field name.
    textAreaFieldName: {
      type: String
    },

    // Selected users field name.
    selectedUsersFieldName: {
      type: String
    },

    // Initial text.
    initialText: {
      type: String,
      default: ""
    },

    // Initial users.
    initialUsers: {
      type: String,
      default: ""
    },

    // Transaction user ID.
    userId: {
      type: Number,
      default: 0
    },

    // Transaction user first name.
    userFirstName: {
      type: String,
      default: ""
    },

    // Transaction user last name.
    userLastName: {
      type: String,
      default: ""
    },

  },

  /**
   * Used components.
   */
  components: {UserTypeahead},

  /**
   * Variables (models).
   */
  data() {
    return {
      text: '',
      users: [],
      userSelected: true,
    }
  },

  /**
   * Computed values
   */
  computed: {

    stringUsers() {
      return JSON.stringify(this.users);
    }

  },

  /**
   * Functions (methods).
   */
  methods: {

    /**
     * Add user to the notification list.
     */
    addNewUser(newUser) {
      let userIndex = this.users.findIndex(user => user.id === newUser.id);
      if (userIndex === -1) {
        this.users.push(newUser);
      }
      this.sortUsers();
    },

    /**
     * Remove user from the notification list.
     */
    removeUser(userId) {
      if (this.users.length === 1) return;
      let userIndex = this.users.findIndex(user => user.id === userId);
      if (userIndex >= 0) {
        this.users = this.users.filter(user => user.id !== userId);
      }
    },

    /**
     * Sort users.
     */
    sortUsers() {
      this.users.sort((a, b) => (a.last_name > b.last_name) ? 1 : -1);
    },

  },

  mounted() {
    this.text = this.initialText;

    if (this.initialUsers === '') {
      if (this.userId > 0) {
        this.users.push({
          id: this.userId,
          first_name: this.userFirstName,
          last_name: this.userLastName,
        });
      }
    } else {
      this.users = JSON.parse(this.initialUsers);
    }
  }
}
</script>

<style scoped>
.user-labels {
  margin-bottom: 0;
}
.user-labels span{
  margin: 3px;
}
</style>
